export enum App {
  D2M = 'DTM',
  TM = 'TM',
}
